module.exports = __WEBPACK_EXTERNAL_MODULE_75__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/Lib","root":["openfl","Lib"],"commonjs":"openfl/Lib","commonjs2":"openfl/Lib"}
// module id = 75
// module chunks = 0